import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";
import commonReducer from "../redux/commonSlice";
import authReducer from "../redux/authSlice";
import crudReducer from "../redux/crudSlice";

export const store = configureStore({
  reducer: {
    common: commonReducer,
    auth: authReducer,
    crud: crudReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
